<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍品名称">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>

      <a-form-item label="拍品图片">
        <UploadFile @callback="uploaded" :mult="false" folder="tuanpai" />
        <div><img style="max-height: 100px" :src="API + form.thumb" alt=""></div>
        <a-input style="width: 600px" placeholder="请输入图片地址" v-model="form.thumb" />
      </a-form-item>

      <a-form-item label="拍品图片">
        <UploadFile @callback="uploaded2" :mult="true" folder="tuanpai" />
        <div>
          <img v-for="(img, index) in form.imgs" :key="index" style="max-height: 100px; margin-right: 10px" :src="API + img.file_path" alt="">
        </div>
      </a-form-item>

      <a-form-item label="赢家限量">
        <a-input-number :min="1" v-model="form.winner_q" />
      </a-form-item>

      <a-form-item label="拍品编号">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.sn"
        ></a-input>
      </a-form-item>

      <a-form-item label="起拍价">
        <a-input-number :min="0" v-model="form.price" /> 元
      </a-form-item>

      <a-form-item label="拍品介绍">
        <Editor
          v-if="done"
          @callback="updateEditor"
          :data="form.desc"
          folder="tuanpai"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">提交修改</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import UploadFile from '../../../components/uploadFile.vue'
import Editor from "../../../components/editor";

export default {
  components: { UploadFile, Editor },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      done: false,
      form: {}
    };
  },
  async created () {
    const id = this.$route.query.id;
    const r = await this.$axios.get('/tuanpai/goods/getInfo?id=' + id);
    console.log(r);
    if(r.status == 1){
      this.form = r.info;
      this.done = true;
    }
  },
  methods: {
    moment,
    uploaded(file) {
      this.form.thumb = file.file_path;
    },
    uploaded2(files) {
      this.form.imgs = files
    },
    updateEditor(data) {
      this.form.desc = data;
    },
    async sub() {
      const that = this;
      const r = await that.$axios.post("/tuanpai/goods/update", this.form);

      if (r.status == 1) {
        this.$router.back()
      }
    }
  },
};
</script>